module.exports = __webpack_public_path__ + "img/img1.518f019a.png";